import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ReferenceCount = () => {
  const faqs = [
    {
      question: "Q: What does Reference Count module do ?",
      answer:
        "A: The Reference Count feature provides a quick summary of the total number of references cited in an IDS (Information Disclosure Statement). It helps users track and manage references across multiple submissions efficiently.",
    },
    {
      question:
        "Q: Why might the reference count appear incorrect for some application numbers ?",
      answer:
        "A: JUNE generates counts based on the XML version of IDS filings available on official patent websites. If the XML data is incomplete or contains errors, those issues will also appear in the Excel output. If you notice discrepancies, please contact our product support team.",
    },
    {
      question:
        "Q: Why do I see a “Failed to fetch data” error for an application number ?",
      answer: (
        <Typography sx={{ whiteSpace: "pre-line" }}>
          A: This error usually occurs when:{"\n\n"}
          • No IDS documents are found for the given application number, or{"\n"}
          • The available IDS PDFs are corrupted or unreadable.
        </Typography>
      ),
    },
    {
      question:
        "Q: Can I check reference counts for multiple applications at once ?",
      answer:
        "A: Yes. The Reference Count feature supports bulk input for up to 100 application numbers per request.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {typeof faq.answer === "string" ? (
              <Typography sx={{ whiteSpace: "pre-line" }}>
                {faq.answer}
              </Typography>
            ) : (
              faq.answer
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default ReferenceCount;
